module.exports = __webpack_public_path__ + "img/MapThumb_BanditHideout.683b47d0.webp";